// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/cssWithMappingToString.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".panel-container{height:100%;width:100%}", "",{"version":3,"sources":["webpack://src/container/DashboardContainer/visualization/panels/Panel.styles.scss"],"names":[],"mappings":"AAAA,iBACC,WAAA,CACA,UAAA","sourcesContent":[".panel-container {\n\theight: 100%;\n\twidth: 100%;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
